import Vue from 'vue'
import VueI18n from 'vue-i18n'
import zh from './lang/zh-CN/zh'
import en from './lang/en/en'
import de from './lang/de/de'
import es from './lang/es/es'

Vue.use(VueI18n)
const i18n = new VueI18n({
  locale: 'zh',
  messages: {zh, en, de, es}
})

export default i18n



// WEBPACK FOOTER //
// ./src/locales/vueIN.js